const en = {
  // Navbar
  "nav.home": "Home",
  "nav.creators": "Creators",
  "nav.campaigns": "Campaigns",
  "nav.rewards": "Rewards",
  "nav.community": "Community",
  "nav.pricing": "Pricing",
  "nav.registerCreator": "Register as Creator",
  "nav.login": "Log In",
  "nav.start": "Get Started",
  "nav.mypage": "My Page",
  "nav.settings": "Settings",
  "nav.logout": "Log Out",
  "nav.tokens": "Tokens",
  "nav.brands": "Brands",

  // Hero Section
  "hero.joinCampaign": "Join Campaign",
  "hero.exploreCreators": "Explore Creators",

  // Service Intro
  "service.howItWorks": "How It Works",
  "service.title": "From K-POP to Dramas, Films & Webtoons",
  "service.titleHighlight": "The Ultimate Entertainment IP Creation Platform",
  "service.desc": "CreatorVerse connects official IPs from K-POP idols, drama studios, film companies and webtoon studios with AI technology so any fan can create amazing content.",
  "service.step.selectIP": "Select IP",
  "service.step.selectIP.desc": "Choose from K-POP, Drama, Film, or Webtoon IPs",
  "service.step.joinCampaign": "Join Campaign",
  "service.step.joinCampaign.desc": "Pick a campaign: music video, drama scene, poster & more",
  "service.step.aiCreate": "Create with AI",
  "service.step.aiCreate.desc": "Use AI tools to craft your unique creation",
  "service.step.shareReward": "Share & Earn",
  "service.step.shareReward.desc": "Share with the community and earn XP rewards",
  "service.cta.title": "Become a Fan Creator Today",
  "service.cta.desc": "K-POP, Drama, Film, Webtoon — create your own content with your favorite IP using AI",
  "service.cta.startCampaign": "Start Campaign",
  "service.cta.exploreIP": "Explore IPs",

  // Latest Campaigns
  "latest.title": "Join Right Now —",
  "latest.titleHighlight": "Latest Entertainment Campaigns",
  "latest.viewAll": "All Campaigns",
  "latest.viewAllCampaigns": "View All Campaigns",
  "latest.filter.all": "All",
  "latest.filter.kpop": "K-POP",
  "latest.filter.drama": "Drama",
  "latest.filter.film": "Film",
  "latest.filter.webtoon": "Webtoon",
  "latest.participation": "Participation",
  "latest.participants": " participants",

  // Footer
  "footer.platform": "Platform",
  "footer.exploreIdols": "Explore Idols",
  "footer.campaigns": "Campaigns",
  "footer.community": "Community",
  "footer.pricing": "Pricing",
  "footer.createCampaign": "Create Campaign",
  "footer.artist": "Artists",
  "footer.artistRegister": "Artist Registration",
  "footer.ipManagement": "IP Management",
  "footer.campaignCreate": "Post Campaign",
  "footer.fanStats": "Fan Analytics",
  "footer.support": "Support",
  "footer.newsletter": "Stay Updated",
  "footer.newsletterDesc": "Get the latest campaigns and idol news",
  "footer.emailPlaceholder": "Email address",
  "footer.subscribed": "Subscribed!",
  "footer.startFree": "Start for Free",
  "footer.terms": "Terms of Service",
  "footer.privacy": "Privacy Policy",
  "footer.copyright": "© 2026 CreatorVerse. All rights reserved.",

  // Campaigns page
  "campaigns.breadcrumb.home": "Home",
  "campaigns.breadcrumb.campaigns": "Campaigns",
  "campaigns.hero.title": "Explore Campaigns",
  "campaigns.hero.titleHighlight": "From All Artists",
  "campaigns.hero.desc": "Dive into campaigns from artists and create AI-powered videos.",
  "campaigns.hero.createVideo": "Create Video",
  "campaigns.filterByArtist": "Campaigns by Artist",
  "campaigns.all": "All",
  "campaigns.noResults": "No results found",
  "campaigns.resetFilters": "Reset Filters",
  "campaigns.total": "",
  "campaigns.totalSuffix": " campaigns",
  "campaigns.searchPlaceholder": "Search by campaign title...",
  "campaigns.allArtists": "All Artists",
  "campaigns.allDifficulty": "All Levels",
  "campaigns.difficulty.easy": "Beginner",
  "campaigns.difficulty.medium": "Intermediate",
  "campaigns.difficulty.hard": "Advanced",
  "campaigns.sort.latest": "Latest",
  "campaigns.sort.popular": "Popular",
  "campaigns.sort.reward": "Top Reward",
  "campaigns.sort.deadline": "Ending Soon",
  "campaigns.progress": "Progress",
  "campaigns.participate": " participating",
  "campaigns.startCampaign": "Start Campaign",

  // Login
  "login.title": "Log In",
  "login.welcome": "Welcome to CreatorVerse!",
  "login.google": "Continue with Google",
  "login.kakao": "Continue with Kakao",
  "login.orEmail": "Or log in with email",
  "login.email": "Email",
  "login.password": "Password",
  "login.forgotPassword": "Forgot password?",
  "login.submit": "Log In",
  "login.loading": "Logging in...",
  "login.noAccount": "Don't have an account?",
  "login.signup": "Sign Up",
  "login.testHint": "Test: any email (with @) + password 8+ characters",
  "login.error.default": "Login failed",

  // Signup
  "signup.step.account": "Account Info",
  "signup.step.profile": "Profile Setup",
  "signup.accountInfo": "Enter Account Info",
  "signup.email": "Email *",
  "signup.password": "Password *",
  "signup.passwordConfirm": "Confirm Password *",
  "signup.next": "Next Step",
  "signup.complete": "Complete Sign Up",
  "signup.hasAccount": "Already have an account?",
  "signup.login": "Log In",
  "signup.profileSetup": "Fan Profile Setup",
  "signup.nickname": "Nickname *",
  "signup.nicknamePlaceholder": "Nickname for the community",
  "signup.favoriteGroup": "Favorite Group (Optional)",
  "signup.agreeTerms": " *",
  "signup.agreeMarketing": "Agree to receive marketing info (Optional)",
  "signup.terms": "Terms of Service",
  "signup.privacy": "Privacy Policy",
  "signup.and": " and ",
  "signup.done.title": "Sign Up Complete!",
  "signup.done.plan": "Plan activated",
  "signup.done.tokenGranted": " tokens granted!",
  "signup.done.joinCampaign": "Join Campaigns",
  "signup.done.goHome": "Go to Home",
  "signup.changePlan": "Change Plan",
  "signup.selectedPlan": "Selected Plan",
  "signup.tokensPerMonth": "tokens/mo",
  "signup.aiUsage": "Used for AI video generation",

  // Common
  "common.language": "Language",
};

export default en;
